import hoistNonReactStatics from 'hoist-non-react-statics';
import { ComponentType, FC, forwardRef, ReactElement } from 'react';
import { setDisplayName, wrapDisplayName } from 'recompose';
import { PermissionRuleName } from 'constant/permission-rules';
import { usePermissionForRule } from 'hooks/permissions/use-permission';

export const withHideIfNotAllowed = <T,>(
  Component: ComponentType<React.PropsWithChildren<T>>,
): FC<React.PropsWithChildren<T & { ruleName?: PermissionRuleName }>> => {
  // eslint-disable-next-line react/display-name
  const Next = forwardRef<any, T & { ruleName?: PermissionRuleName }>(
    ({ ruleName, ...props }, ref) => {
      const { isAllowedForCurrentUser } = usePermissionForRule();

      return ruleName == null || isAllowedForCurrentUser(ruleName) ? (
        <Component {...(props as any)} ref={ref} />
      ) : (
        <></>
      );
    },
  );

  return setDisplayName(wrapDisplayName(Component, 'withHideIfNotAllowed'))(
    hoistNonReactStatics(Next, Component),
  ) as any;
};

export const HideIfNotAllowed: FC<
  React.PropsWithChildren<{ ruleName: PermissionRuleName }>
> = ({ ruleName, children }) => {
  const { isAllowedForCurrentUser } = usePermissionForRule();

  return isAllowedForCurrentUser(ruleName) ? <>{children}</> : <></>;
};

export const SwitchContentBasedOnAccess: FC<
  React.PropsWithChildren<{
    ruleName: PermissionRuleName;
    hasAccess: ReactElement;
    doesNotHaveAccess: ReactElement;
  }>
> = ({ ruleName, hasAccess, doesNotHaveAccess }) => {
  const { isAllowedForCurrentUser } = usePermissionForRule();

  return isAllowedForCurrentUser(ruleName) ? hasAccess : doesNotHaveAccess;
};
